import Axios from "axios";
import {
    SET_LEAD_DETAILS_ROUTES_LIST,
    UNSET_LEAD_DETAILS_ROUTES_LIST,
} from "@/store/mutation-types";
import {
    saveUpdateSalesLeadActivityLog,
    getSalesLeadActivityLog,
    getLeadActivityLogById,
} from "@/store/api";
// initial state
const state = {
    getSalesLeadActivityLog: [],
    editingSalesLeadDetails: null,
};

const getters = {
    getSalesLeadActivityLog(state) {
        return state.getSalesLeadActivityLog;
    },
    getEditingSalesLeadDetails: (state) => state.editingSalesLeadDetails,
};

const mutations = {
    [SET_LEAD_DETAILS_ROUTES_LIST](state, data) {
        state.getSalesLeadActivityLog = data;
    },
    [UNSET_LEAD_DETAILS_ROUTES_LIST](state) {
        state.getSalesLeadActivityLog = [];
    },
    setEditingSalesLeadDetails(state, lead) {
        state.editingSalesLeadDetails = lead;
    },
};

const actions = {
    saveUpdateSalesLeadActivityLog({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalesLeadActivityLog, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesLeadActivityLog({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadActivityLog, data)
                .then(function (response) {
                    commit("SET_LEAD_DETAILS_ROUTES_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_LEAD_DETAILS_ROUTES_LIST");
                    reject(error);
                })
        });
    },

    getSalesLeadActivityLogById({ commit }, data) {
        const getSalesLeadActivityLogById = `${getLeadActivityLogById}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadActivityLogById)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING")
                });
        });
    },

    getGeneratedSalesLeadsCode({ commit }) {
        return new Promise((resolve, reject) => {
            Axios.get(generateSalesLeadsCode)
                .then((response) => {
                    resolve(response.data.code);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
